import { cn } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import type { Address } from "viem";

import type {
  CreditAccountOperation,
  OperationDetails,
  TokensList,
} from "../model";
import { isMulticallOperation } from "../model";
import type { ProtocolsList } from "../protocols";
import { GEARBOX_PROTOCOL_INFO } from "../protocols";
import { Details, Protocol } from "./cells";

export interface HistoryLineProps {
  data: CreditAccountOperation;
  details: OperationDetails;
  tokens: TokensList;
  protocols: ProtocolsList;
  hideBorder: boolean;
  index: { index: number; outOf: number };
  underlyingToken: Address;
  chainId: number;
}

export const HistoryLine: FC<HistoryLineProps> = ({
  data,
  details,
  tokens,
  protocols,
  hideBorder,
  index,
}) => {
  const protocol =
    protocols[data.protocol.toLowerCase() as Address] ?? GEARBOX_PROTOCOL_INFO;

  const isMulticall = isMulticallOperation(data);
  const isRoot = index.index === 0;
  const showDetails = (isRoot && index.outOf === 0) || !isRoot;

  return (
    <>
      {isRoot && (
        <div className="col-span-3 pt-4 pb-2 flex flex-row justify-between items-center gap-2">
          <div className="text-sm">
            {data.date} {data.time}
            {isMulticall && ` - ${data.operation}`}
          </div>
        </div>
      )}

      {showDetails && (
        <>
          <div
            className={cn(
              "py-2 text-sm border-b border-gray-700",
              !isRoot && "pl-6",
              hideBorder && "border-b-0",
            )}
          >
            <Protocol isUnderlying={!isRoot} protocol={protocol} />
          </div>
          <div
            className={cn(
              "py-2 text-sm border-b border-gray-700",
              hideBorder && "border-b-0",
            )}
          >
            {!isMulticall ? data.operation : null}
          </div>
          <div
            className={cn(
              "py-2 text-sm border-b border-gray-700",
              hideBorder && "border-b-0",
            )}
          >
            <Details data={details} tokens={tokens} />
          </div>
        </>
      )}
    </>
  );
};
